<ckeditor
    required
    [config]="editorConfig"
    [editor]="Editor"
    [data]="content"
    (ready)="onReady($event)"
    (change)="onContentChange()"
    [class]="cssClass"
>
</ckeditor>
<small class="stats-subtext">{{ editor_count }}</small>
